import * as React from "react";

export const SeparatorIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width={41} height={33} fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x={37.733} y={10.961} width={3} height={14.945} rx={1} fill="#D9D9D9" />
    <rect x={0.733} y={10.961} width={3} height={14.945} rx={1} fill="#D9D9D9" />
    <rect x={0.733} y={16.992} width={40} height={3} rx={1} fill="#D9D9D9" />
  </svg>
);

export const SpacerIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width={41} height={68} fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x={37.19} y={30.324} width={3} height={10} rx={1} fill="#D9D9D9" />
    <rect x={0.19} y={30.324} width={3} height={10} rx={1} fill="#D9D9D9" />
    <rect x={0.19} y={37.324} width={40} height={3} rx={1} fill="#D9D9D9" />
    <rect x={3.19} y={2.326} width={3} height={10} rx={1} transform="rotate(180 3.19 32.326)" fill="#D9D9D9" />
    <rect x={40.19} y={2.326} width={3} height={10} rx={1} transform="rotate(180 40.19 32.326)" fill="#D9D9D9" />
    <rect x={40.19} y={-5.326} width={40} height={3} rx={1} transform="rotate(180 40.19 25.326)" fill="#D9D9D9" />
  </svg>
);

export const DividerIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width={41} height={68} fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x={0.19} y={44.824} width={40} height={3} rx={1} fill="#D9D9D9" />
  </svg>
);
